<script>
// import { mapState } from 'vuex';
import LogoAnimated from '@/components/LogoAnimated.vue';
import RoundedBox from '@/components/RoundedBox.vue';
import SiteIntro from '@/components/landing/SiteIntro.vue';
import CardIntros from '@/components/landing/CardIntros.vue';
import AppIntro from '@/components/landing/AppIntro.vue';
import AboutSection from '@/components/landing/AboutSection.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'LandingView',

  components: {
    LogoAnimated,
    RoundedBox,
    SiteIntro,
    CardIntros,
    AppIntro,
    AboutSection,
    Footer,
  },

  data() {
    return {
      rousseauQuote: {
        content: 'The world of reality has its limits; the world of imagination is boundless.',
        title: 'Jean-Jacques Rousseau',
      },

      patersonQuote: {
        content: 'Just close your eyes and keep your mind wide open.',
        title: 'Katherine Paterson',
      },

      eliotQuote: {
        content: 'Adventure is not outside man; it is within.',
        title: 'George Eliot',
      },

      anneQuote: {
        content: 'Because when you are imagining, you might as well imagine something worthwhile.',
        title: 'Lucy Maud Montgomery, Anne of Green Gables',
      },
    };
  },

  // computed: {
  //   ...mapState('strings', {
  //     rousseauQuote: state => state.marketing['quote-rousseau-boundless'] || {},
  //     anneQuote: state => state.marketing['quote-anne-worthwhile'] || {},
  //     eliotQuote: state => state.marketing['quote-eliot-adventure'] || {},
  //   }),
  // },

  // beforeCreate() {
  //   this.$store.dispatch('strings/getStringByType', 'marketing');
  // },
  //
};
</script>

<template>
  <div class="landing">
    <div class="home-grid">
      <div class="logo-header">
        <LogoAnimated class="logo-container" />
        <mq-layout mq="md+" class="intro-card">
          <RoundedBox center>
            <SiteIntro />
          </RoundedBox>
        </mq-layout>
      </div>

      <div class="main">
        <mq-layout :mq="['sm']">
          <SiteIntro />
        </mq-layout>

        <hr class="divider" />

        <div>
          <span class="quote thin-font"> &ldquo;{{ rousseauQuote.content }}&rdquo; </span>
          <span class="author">
            {{ rousseauQuote.title }}
          </span>
        </div>

        <hr class="divider" />

        <CardIntros />

        <hr class="divider" />

        <div>
          <span class="quote thin-font"> &ldquo;{{ patersonQuote.content }}&rdquo; </span>
          <span class="author">
            {{ patersonQuote.title }}
          </span>
        </div>

        <hr class="divider" />

        <AppIntro />

        <hr class="divider" />

        <div>
          <span class="quote thin-font"> &ldquo;{{ eliotQuote.content }}&rdquo; </span>
          <span class="author">
            {{ eliotQuote.title }}
          </span>
        </div>

        <hr class="divider" />

        <AboutSection />

        <hr class="divider" />

        <div>
          <span class="quote thin-font"> &ldquo;{{ anneQuote.content }}&rdquo; </span>
          <span class="author">
            {{ anneQuote.title }}
          </span>
        </div>

        <hr class="divider" />
      </div>

      <Footer class="footer" />
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/variables.scss';

.landing {
  .home-grid {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      'header'
      'main'
      'footer';
    grid-gap: 1rem;
    align-content: flex-start;
    justify-items: center;
    min-height: 100vh;
    width: 100%;
  }

  .logo-header {
    display: flex;
    grid-area: header;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 7rem 12vw;
    background-image: url('~@/assets/backgrounds/BlueBackground.svg?external');
    background-repeat: no-repeat;
    background-size: 150%;
    background-position: bottom;

    .lg & {
      padding: 5rem 8vw;
    }

    .md & {
      padding: 3rem 2rem 2rem 2rem;
    }

    .sm & {
      flex-direction: column;
      justify-content: center;
      padding: 3rem 2rem 2rem 2rem;
    }
  }

  .logo-container {
    width: 50%;
    height: auto;
    padding-right: 1rem;

    .sm & {
      width: 100%;
      min-height: 15rem;
      padding: 0;
    }
  }

  .intro-card {
    width: 50%;
  }

  .main {
    grid-area: main;
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 0 12vw;

    .md &,
    .lg & {
      padding: 0 8vw;
    }

    .sm & {
      // min-height: 15rem;
      padding: 0 1rem;
    }
  }

  .divider {
    background-color: $blue-light;
    margin: 1rem 0;
  }

  .section {
    padding: 1rem 0;
  }

  .footer {
    grid-area: footer;
  }

  .section-title {
    width: 100%;
    text-align: center;
  }

  .subtitle {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.2rem;
    letter-spacing: 0;
  }

  .quote {
    display: block;
    margin-bottom: 1rem;
    text-align: center;
    font-size: 1.3rem;
    letter-spacing: 0.5px;
  }

  .author {
    display: block;
    text-align: center;
    font-size: 0.8rem;
  }

  ol {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }

  ol,
  ul {
    margin-left: 1.5rem;
  }

  li {
    line-height: 1.4em;
    margin-bottom: 0.75rem;
  }

  .get-app-button {
    min-width: fit-content;
    width: 200px;
    margin-top: 1.5rem;
    font-size: 1.2rem;
    letter-spacing: 0.04rem;
  }

  .button-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }
}
</style>
